import { render } from "./AppealsTab.vue?vue&type=template&id=165f37a2&scoped=true"
import script from "./AppealsTab.vue?vue&type=script&lang=js"
export * from "./AppealsTab.vue?vue&type=script&lang=js"

import "./AppealsTab.vue?vue&type=style&index=0&id=165f37a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165f37a2"]])

export default __exports__